export const pl = {
  billing: {
    title: 'Płatności i Subskrypcja',
    description: 'Zarządzaj swoją subskrypcją i informacjami o płatnościach',
    currentPlan: 'Aktualny Plan',
    upgradePlan: 'Uaktualnij Swój Plan',
    choosePlan: 'Wybierz plan, który jest dla Ciebie najlepszy',
    features: 'Funkcje',
    billingInfo: 'Informacje o Płatnościach',
    currentPeriod: 'Obecny Okres',
    manageSubscription: 'Zarządzaj Subskrypcją',
    selectPlan: 'Wybierz {plan}',
    popular: 'Popularny',
    savePercent: 'Oszczędź {percent}%',
    perMonth: '/miesiąc',
    perYear: '/rok',
    billedAnnually: '(płatne rocznie)',
    memberLimit: 'Do {count} członków rodziny',
    memberLimitUnlimited: 'Bez limitu członków rodziny',
    monthly: 'Miesięcznie',
    annual: 'Rocznie',
    success: {
      title: 'Subskrypcja Aktywowana!',
      description: 'Twoja płatność przebiegła pomyślnie i subskrypcja jest teraz aktywna.',
      message: 'Masz teraz dostęp do wszystkich funkcji premium. Dziękujemy za zakup!',
      planActivated: 'został aktywowany',
      goToApp: 'Przejdź do Aplikacji',
      manageBilling: 'Zarządzaj Płatnościami',
      continue: 'Przejdź do Płatności',
    },
    cancel: {
      title: 'Płatność Anulowana',
      description: 'Twoja płatność została anulowana i nie zostały naliczone żadne opłaty.',
      message: 'Możesz spróbować ponownie w dowolnym momencie. Jeśli potrzebujesz pomocy, skontaktuj się z naszym zespołem wsparcia.',
      tryAgain: 'Spróbuj Ponownie',
      goToApp: 'Przejdź do Aplikacji',
    },
    status: {
      active: 'Aktywny',
      canceled: 'Anulowany',
      canceling: 'Anulowanie',
      pastDue: 'Zaległości',
      grandfathered: 'Dożywotni',
    },
    grandfathered: {
      title: 'Dożywotni Dostęp Pro',
      message: 'Masz dożywotni dostęp do funkcji Pro. Dziękujemy za bycie wczesnym wsparciem!',
    },
    planSuffix: 'Plan',
    currentPeriodLabel: 'Obecny Okres:',
    subscriptionWillCancel: 'Subskrypcja zostanie anulowana w dniu',
    paymentsComingSoon: 'Płatności online będą dostępne wkrótce. Plany można obecnie zmieniać ręcznie.',
    plans: {
      free: {
        name: 'Darmowy',
        description: 'Zacznij z podstawowymi funkcjami',
        fullName: 'Plan Darmowy',
        features: {
          memberLimit: 'Do 2 członków rodziny',
          shoppingLists: 'Współdzielone listy zakupów',
          recipes: 'Współdzielone przepisy rodzinne',
          keepExport: 'Eksport do Google Keep',
          aiByok: 'Import AI z własnym kluczem OpenRouter',
        },
      },
      basic: {
        name: 'Basic',
        description: 'Dla mniejszych rodzin',
        fullName: 'Plan Basic',
        features: {
          memberLimit: 'Do 5 członków rodziny',
          everythingInFree: 'Wszystko z planu Darmowy',
          aiImport: 'Import przepisów AI (klucz systemowy, limit)',
        },
      },
      pro: {
        name: 'Pro',
        description: 'Bez limitu członków + większy AI',
        fullName: 'Plan Pro',
        features: {
          memberLimit: 'Bez limitu członków rodziny',
          everythingInBasic: 'Wszystko z planu Basic',
          aiImport: 'Wyższy limit AI (klucz systemowy)',
        },
      },
    },
    upgradeBanner: {
      title: 'Potrzebujesz więcej członków lub AI?',
      description: 'Przejdź na plan Basic lub Pro, aby zaprosić więcej osób i korzystać z importu AI.',
      button: 'Zobacz Plany',
    },
    errors: {
      checkoutFailed: 'Nie udało się utworzyć sesji checkout. Spróbuj ponownie.',
      portalFailed: 'Nie udało się otworzyć portalu rozliczeniowego. Spróbuj ponownie.',
      ownerOnly: 'Tylko właściciel rodziny może zarządzać płatnościami.',
    },
  },
}
